import React from 'react';
import ManageCategories from '../ManageCategories';
import { SectionShell } from './_shared';

export default function CategoriesSection() {
  return (
    <SectionShell eyebrow="Categories" title="Categories" description="Edit buckets, rename, lock the preset list, and attach tax codes." testid="section-categories">
      <ManageCategories />
    </SectionShell>
  );
}
